import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { useMusic24Capabilities } from '../../../hooks/useMusic24Capabilities';
import { reelRejectMessages } from './reelReviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The video credit box of the reject sheet (design e1). The app has no used count, so it shows
 * the monthly allowance of the plan. An unlimited plan (`null`) shows no allowance, as in the rail.
 */
const ReelRejectQuotaComponent: React.FC<{ releaseTitle?: string }> = ({ releaseTitle }) => {
  const intl = useIntl();
  const { videoCreditsPerMonth } = useMusic24Capabilities();

  return (
    <div className={styles.qbox}>
      <div className={styles.qrow}>
        <span>{intl.formatMessage(reelRejectMessages.usesOne)}</span>
        {videoCreditsPerMonth !== null && (
          <span className={styles.qvalue}>
            {intl.formatMessage(reelRejectMessages.allowance, { limit: videoCreditsPerMonth })}
          </span>
        )}
      </div>
      <span className={styles.secHint}>
        {releaseTitle === undefined
          ? intl.formatMessage(reelRejectMessages.staysInHistoryNoRelease)
          : intl.formatMessage(reelRejectMessages.staysInHistory, { release: releaseTitle })}
      </span>
    </div>
  );
};

export const ReelRejectQuota = TypedMemo(ReelRejectQuotaComponent);
